/*
 * Authors: mariushirjanu
 * Created: 06/01/2023
 */
import { trackByFunction } from '../../../../shared/formly/ga-formly.util';
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CatalogCategoryType } from './catalog-overview.service';
import { INumericObject } from '../../../../../type_definitions/datatypes';
import { ICatalogCategory } from '../order-catalog-data.service';

@Component({
  selector: 'catalog-categories',
  template: `
    <div class="categories clearfix">
      <div class="btn-group">
      <ng-container *ngFor="let category of categories; trackBy: trackByFunction">
        <button *ngIf="categoryCount(category.name) > 0 || category.type === '${CatalogCategoryType.EXTERNAL}'" type="button" class="btn" [ngClass]="{active: category.name === selectedCategoryName}" (click)="onSelectCategory.emit(category)">{{category.name}}
          <span *ngIf="category.type !== '${CatalogCategoryType.EXTERNAL}'">({{categoryCount(category.name)}})</span>
          <i *ngIf="punchoutIsLoading && category.name === selectedCategoryName" class="fa fa-spinner fa-spin activity-indicator"></i>
        </button>
      </ng-container>
    </div>
    </div>
  `
})
export class CatalogCategoriesComponent implements OnChanges {
  @Input() public categories:ICatalogCategory[];
  @Input() public punchoutIsLoading:boolean;
  @Input() public selectedCategoryName:string;
  @Input() public categoryCounts:INumericObject = {};
  @Output() public onSelectCategory:EventEmitter<ICatalogCategory> = new EventEmitter<ICatalogCategory>();
  public trackByFunction:Function = trackByFunction;

  constructor() {
    /***/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if(changes.categoryCounts){
      this.categoryCounts = changes.categoryCounts.currentValue;
    }

    if (changes.categories) {
      this.categories = changes.categories.currentValue;
    }

    if(changes.selectedCategoryName){
      this.selectedCategoryName = changes.selectedCategoryName.currentValue;
    }

    if(changes.punchoutIsLoading){
      this.punchoutIsLoading = changes.punchoutIsLoading.currentValue;
    }
  }

  public categoryCount(categoryName:string):number {
    return this.categoryCounts[categoryName] || 0;
  }
}